import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import isEqual from 'lodash/isEqual';
import { Provider, getDefaultStore } from 'jotai';
import MetricLens from '@components/metric-lens';
import { PAGE_TYPE } from '@utils/constants';
import { selectors as tabsStoreSelector } from '@store/dashboards/tabs';
import usePageTitle from '@src/hooks/usePageTitle';
import useKPI from '@src/hooks/useKPI';
import { Wrapper } from './styled';
import { useParams } from 'react-router-dom';

// Use the same default store the saga uses so currentKpiId etc. are in one place (no ref needed).
const defaultStore = getDefaultStore();

const Dashboard = (props) => {
  const { pageType, mlBase, store = defaultStore } = props;
  const { id: currentShareId = 'metriclens' } = useParams();
  const tabs = useSelector(tabsStoreSelector);

  usePageTitle({ text: 'Metric Lens' });
  useKPI();

  useEffect(() => {
    if (
      pageType === PAGE_TYPE.SHARING &&
      tabs.tabsData[currentShareId] &&
      !isEqual(mlBase, tabs.tabsData[currentShareId].config.base)
    ) {
      tabs.tabsData[currentShareId].config.base = mlBase;
      tabs.tabsData[currentShareId].unsaved = true;
      tabs.tabsData[currentShareId].isSaved = false;
    }
  }, [mlBase, currentShareId]);

  return (
    <Provider store={store}>
      <Wrapper>
        <MetricLens {...props} />
      </Wrapper>
    </Provider>
  );
};

export default Dashboard;
